import { fromJS } from 'immutable';
import { actions } from 'react/api/actions/stockSummaryModal';

const initialState = fromJS({
  isOpen: false,
  isLoading: false
});

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.open:
      return state.set('isOpen', true);
    case actions.close:
      return state.merge(initialState);
    default:
      return state;
  }
};
